import { combineReducers } from 'redux';
import sessionErrorsReducer from './session_errors_reducer';

export default combineReducers({
  session: sessionErrorsReducer
});



// WEBPACK FOOTER //
// ./lib/reducers/errors_reducer.js